import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { ApilistService } from 'src/app/services/apilist.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { AgGridModule } from 'ag-grid-angular';
import { AgGridAngular } from 'ag-grid-angular';
import {
  GridApi,
  GridReadyEvent,
  CellClickedEvent,
  ColDef,
} from 'ag-grid-community';

import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-add-college-course',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AgGridModule],
  templateUrl: './add-college-course.component.html',
  styleUrls: ['./add-college-course.component.scss'],
})
export class AddCollegeCourseComponent implements OnInit, OnDestroy {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  @ViewChild('boxCollege', { static: false }) boxCollege: ElementRef;

  collegeId: any;
  display: any = 'none';
  courseaddForm: UntypedFormGroup;

  scopeIdArray: any[] = [];

  searchval: any = '';

  error_messages = {
    collegeName: [{ type: 'required', message: 'please select college name.' }],
    checkVal: [{ type: 'required', message: 'please select courses.' }],
    feesVal: [{ type: 'required', message: 'please enter fees.' }],
    trustFeesVal: [{ type: 'required', message: 'please enter trust fees.' }],
  };
  colleges: any[] = [];
  scopeData: any[] = [];
  courseDetails: any[] = [];
  adminName: any;
  adminImage: any;
  allCourse: any[] = [];
  allData: any[] = [];

  showData = false;
  showNodata = false;

  showAdd = false;
  showEdit = false;
  trustFees: any;
  fees: any;
  courseName: any;
  id: any;
  clgId: any;
  deleteErr: any;
  displayDelete = 'none';
  course_id: any;
  showErr = false;

  // AG Grid fields
  private gridApi!: GridApi;
  rowData: any[] = [];
  originalRowData: any[] = [];
  private quickFilterSubject = new Subject<string>();
  private quickFilterSub!: Subscription;

  // COLUMN DEFINITIONS — GROUP BY college_name (hide the raw column so group header shows it)
  columnDefs: ColDef[] = [
    // Group by college_name; hide this raw column so the autoGroup column shows the header
    {
      headerName: 'College',
      field: 'college_name',
      rowGroup: true,
      hide: false,
      minWidth: 260,
      sortable: true,
      filter: 'agTextColumnFilter',
    },

    // Child row columns
    {
      headerName: 'Degree',
      field: 'degree',
      minWidth: 140,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      headerName: 'Course',
      field: 'course_name',
      minWidth: 200,
      flex: 2,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      headerName: 'Course Type',
      field: 'course_type',
      minWidth: 140,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Fees',
      field: 'fees',
      minWidth: 120,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Trust Fees',
      field: 'trust_fees',
      minWidth: 120,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'center' },
    },

    // Actions column
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 140,
      maxWidth: 180,
      cellRenderer: (params: any) => {
        return `
          <div style="display:flex;gap:8px;justify-content:center">
            <button class="btn btn-link" data-action="edit" title="Edit"><i class="fa fa-pencil"></i></button>
            <button class="btn btn-link text-danger" data-action="delete" title="Delete"><i class="fa fa-trash-o"></i></button>
          </div>
        `;
      },
      suppressSizeToFit: true,
    },
  ];

  // autoGroupColumnDef renders the group header (college name + count + expand/collapse)
  autoGroupColumnDef = {
    headerName: 'College',
    minWidth: 300,
    cellRendererParams: {
      suppressCount: false, // show "(n)"
      // default inner renderer (shows the key)
    },
  };

  // grid options: groupRows display gives classic "Group ▼ (n)" header with children below
  gridOptions = {
    rowHeight: 50,
    pagination: true,
    paginationPageSize: 10,
    groupDefaultExpanded: 0, // 0 collapsed by default
    animateRows: true,
  };

  // after
  groupDisplayType: 'multipleColumns' = 'multipleColumns';

  defaultColDef: ColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    minWidth: 100,
    flex: 1,
  };

  constructor(
    public formBuilder: UntypedFormBuilder,
    public commonservice: CommonService,
    public utils: ApilistService,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.courseaddForm = this.formBuilder.group({
      collegeName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      checkVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      feesVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      trustFeesVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    // parse admin details safely
    try {
      const admin = localStorage.getItem('adminDetails');
      if (admin) {
        const parsed = JSON.parse(admin);
        const adminData =
          typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
        this.adminName = adminData[0]?.name;
        this.adminImage = adminData[0]?.image;
      }
    } catch {
      this.adminName = '';
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
    if (!this.adminImage) this.adminImage = 'assets/tenant-avatar.jpg';

    // debounce subject subscribe
    this.quickFilterSub = this.quickFilterSubject
      .pipe(debounceTime(250))
      .subscribe((q) => {
        if (this.gridApi) {
          (this.gridApi as any).setGridOption('quickFilterText', q ? q : null);
          this.gridApi.refreshClientSideRowModel('filter');
        }
      });
  }

  ngOnInit(): void {
    this.courseaddForm.reset();
    this.loadInitialDataInline(); // inline fetch + normalize/flatten
  }

  ngOnDestroy(): void {
    if (this.quickFilterSub) this.quickFilterSub.unsubscribe();
  }

  // INLINE: fetch all required data and normalize/flatten in this component
  private async loadInitialDataInline() {
    this.spinner.show();

    const servicePathCollege = this.utils.getApiConfigs('college');
    const servicePathScope = this.utils.getApiConfigs('scope');
    const servicePathCourses = this.utils.getApiConfigs(
      'individualcollegecourse'
    );

    try {
      const [collegeResRaw, scopeResRaw, courseResRaw] = await Promise.all([
        this.commonservice.invokeService(
          servicePathCollege[1].method,
          servicePathCollege[1].path,
          ''
        ),
        this.commonservice.invokeService(
          servicePathScope[1].method,
          servicePathScope[1].path,
          ''
        ),
        this.commonservice.invokeService(
          servicePathCourses[0].method,
          servicePathCourses[0].path,
          ''
        ),
      ]);

      const collegeRes: any = collegeResRaw as any;
      const scopeRes: any = scopeResRaw as any;
      const courseRes: any = courseResRaw as any;

      this.spinner.hide();

      this.colleges =
        collegeRes &&
        (collegeRes.status_code === '200' || collegeRes.status === 200)
          ? collegeRes.data || []
          : [];
      this.scopeData =
        scopeRes && (scopeRes.status_code === '200' || scopeRes.status === 200)
          ? scopeRes.data || []
          : [];
      this.courseDetails =
        courseRes &&
        (courseRes.status_code === '200' || courseRes.status === 200)
          ? courseRes.data || []
          : [];

      // INLINE normalization & flattening: ensure each final row has college_name (flatten nested courses -> rows)
      const flattened: any[] = [];
      (this.courseDetails || []).forEach((item: any) => {
        const collegeName =
          item.college_name ??
          item.collage_name ??
          item.collegeName ??
          item.collageName ??
          item.college ??
          '';

        const collegeId =
          item.college_id ??
          item.id ??
          item.collegeId ??
          item.collage_id ??
          null;

        if (Array.isArray(item.courses) && item.courses.length) {
          item.courses.forEach((cd: any) => {
            flattened.push({
              college_id: collegeId,
              college_name: collegeName,
              degree: cd.degree ?? cd.degree_name ?? '',
              course_name: cd.course_name ?? cd.courseName ?? cd.name ?? '',
              course_type: cd.course_type ?? cd.type ?? '',
              fees: cd.fees ?? cd.fee ?? '',
              trust_fees: cd.trust_fees ?? cd.trustFees ?? '',
              college_details_id: cd.college_details_id ?? cd.id ?? null,
              rawCollege: item,
              rawCourse: cd,
            });
          });
        } else {
          flattened.push({
            college_id: collegeId,
            college_name: collegeName,
            degree: item.degree ?? '',
            course_name: item.course_name ?? item.courseName ?? item.name ?? '',
            course_type: item.course_type ?? item.type ?? '',
            fees: item.fees ?? item.fee ?? '',
            trust_fees: item.trust_fees ?? item.trustFees ?? '',
            college_details_id: item.college_details_id ?? item.id ?? null,
            rawCollege: item._sourceCollege ?? null,
            rawCourse: item,
          });
        }
      });

      // assign to grid
      this.allCourse = flattened;
      this.allData = [...flattened];

      if (!this.allCourse || this.allCourse.length === 0) {
        this.showNodata = true;
        this.showData = false;
        this.rowData = [];
        this.originalRowData = [];
      } else {
        this.showData = true;
        this.showNodata = false;
        this.rowData = flattened;
        // keep original copy for reset
        if (this.gridApi) {
          try {
            (this.gridApi as any).setRowData(this.rowData);
            // ensure group rendering refresh
            this.gridApi.refreshClientSideRowModel('group');
          } catch {
            this.gridApi.refreshClientSideRowModel('filter');
          }
        }
        this.originalRowData = JSON.parse(JSON.stringify(flattened));
      }

      // debug check: ensure college_name exists
      // console.log('SAMPLE ROW', this.rowData[0]);

      // If grid already ready, push data in
      if (this.gridApi) {
        try {
          (this.gridApi as any).setRowData(this.rowData);
        } catch {
          this.gridApi.refreshClientSideRowModel('filter');
        }
      }
    } catch (err) {
      this.spinner.hide();
      console.error('Error loading data (inline)', err);
      this.globalService.showError('Error loading data');
    }
  }

  // AG Grid ready
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    setTimeout(() => {
      try {
        this.gridApi.sizeColumnsToFit();
      } catch (e) {}
    }, 0);

    // if rows already loaded, push them in
    if (this.rowData && this.rowData.length) {
      try {
        (this.gridApi as any).setRowData(this.rowData);
      } catch {
        this.gridApi.refreshClientSideRowModel('filter');
      }
    }

    // attach cellClicked listener for action buttons
    this.gridApi.addEventListener(
      'cellClicked',
      (event: CellClickedEvent | any) => {
        const nativeTarget = event.event?.target as HTMLElement | null;
        if (!nativeTarget) return;
        const btn = nativeTarget.closest('button');
        if (!btn) return;
        const action = btn.getAttribute('data-action');
        if (!action) return;
        const data = event.data;
        if (!data) return;

        if (action === 'view') {
          this.viewCollege(data);
        } else if (action === 'edit') {
          // open edit modal for this course
          this.showEdit = true;
          this.showAdd = false;
          this.display = 'block';

          this.collegeId = data.college_name;
          this.clgId = data.college_id;
          this.courseName = `${data.course_type} - ${data.course_name}`;
          this.fees = data.fees;
          this.trustFees = data.trust_fees;
          this.id = data.college_details_id;
        } else if (action === 'delete') {
          this.deleteCourse(data);
        }
      }
    );
  }

  // debounced quick filter
  onQuickFilterChanged(value: string) {
    this.searchval = value;
    this.quickFilterSubject.next(value || '');
  }

  // reset search + grid filters
  reset() {
    this.searchval = '';
    if (this.gridApi) {
      (this.gridApi as any).setGridOption('quickFilterText', null);
      this.gridApi.setFilterModel(null);
      try {
        (this.gridApi as any).setRowData(this.originalRowData || []);
      } catch {
        this.gridApi.refreshClientSideRowModel('filter');
      }
    } else {
      this.rowData = JSON.parse(JSON.stringify(this.originalRowData || []));
    }
  }

  onChangeEvent(event: any) {
    const val = event?.target?.value;
    this.allData = this.allCourse;
    if (val) {
      const filtered = (this.allData || []).filter(
        (item: any) =>
          (item.course_name ?? '')
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase()) ||
          (item.degree ?? '')
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase()) ||
          (item.college_name ?? '')
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase())
      );
      this.rowData = filtered;
    } else {
      this.rowData = [...this.allCourse];
    }

    if (this.gridApi) {
      try {
        (this.gridApi as any).setRowData(this.rowData);
      } catch {
        this.gridApi.refreshClientSideRowModel('filter');
      }
    }

    if (!this.rowData || this.rowData.length === 0) {
      this.globalService.showError('No data found');
    }
  }

  resetSearch() {
    this.loadInitialDataInline();
    this.searchval = '';
  }

  openAdd() {
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
    this.courseaddForm.reset();
    (this.scopeData || []).forEach((s) => (s.check = false));
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  editCourse(college: any, coursedetails: any) {
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.collegeId = college.college_name ?? college.collegeName ?? '';
    this.clgId = college.college_id ?? college.id ?? null;
    this.courseName =
      coursedetails.course_type + '-' + coursedetails.course_name;
    this.fees = coursedetails.fees;
    this.trustFees = coursedetails.trust_fees;
    this.id = coursedetails.college_details_id ?? coursedetails.id ?? null;
  }

  addCourses() {
    this.spinner.show();
    this.scopeIdArray = [];
    for (let i = 0; i < (this.scopeData || []).length; i++) {
      if (
        this.scopeData[i].fees != null &&
        this.scopeData[i].trustFees != null
      ) {
        this.scopeIdArray.push({
          college_id: this.collegeId,
          scope_id: this.scopeData[i].id,
          fees: this.scopeData[i].fees,
          trust_fees: this.scopeData[i].trustFees,
        });
      }
    }

    const payload = { scopes: this.scopeIdArray };
    const servicePath = this.utils.getApiConfigs('collegedetails');

    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((respRaw: any) => {
        const resp: any = respRaw as any;
        this.spinner.hide();
        if (resp && (resp.status_code === '200' || resp.status === 200)) {
          this.globalService.showSuccess('Course Details added Successfully');
          this.display = 'none';
          this.loadInitialDataInline();
          this.courseaddForm.reset();
        } else {
          this.globalService.showError(resp?.data ?? 'Error adding courses');
          this.display = 'none';
        }
      })
      .catch((err) => {
        this.spinner.hide();
        this.globalService.showError('Error adding courses');
        console.error(err);
      });
  }

  updateCourses() {
    this.spinner.show();
    const payload: any = {
      id: this.id,
      college_id: this.clgId,
      trust_fees: this.trustFees,
      fees: this.fees,
    };

    const servicePath = this.utils.getApiConfigs('editcollegedetails');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((respRaw: any) => {
        const resp: any = respRaw as any;
        this.spinner.hide();
        if (resp && (resp.status_code === '200' || resp.status === 200)) {
          this.globalService.showSuccess('Course Details updated Successfully');
          this.display = 'none';
          this.loadInitialDataInline();
          this.courseaddForm.reset();
        } else {
          this.globalService.showError(resp?.data ?? 'Error updating course');
          this.display = 'none';
        }
      })
      .catch((err) => {
        this.spinner.hide();
        this.globalService.showError('Error updating course');
        console.error(err);
      });
  }

  deleteCourse(data: any) {
    this.deleteErr = '';
    this.displayDelete = 'block';
    this.course_id = data.college_details_id ?? data.id ?? null;
  }

  delete() {
    this.spinner.show();
    const payload = { id: this.course_id };
    const servicePath = this.utils.getApiConfigs('deletecollegedetails');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((respRaw: any) => {
        const resp: any = respRaw as any;
        this.spinner.hide();
        if (resp && (resp.status_code === '200' || resp.status === 200)) {
          this.globalService.showSuccess(
            resp.message ?? 'Deleted successfully'
          );
          this.displayDelete = 'none';
          this.loadInitialDataInline();
        } else {
          this.spinner.hide();
          this.showErr = true;
          this.deleteErr = resp?.message ?? 'Error deleting';
        }
      })
      .catch((err) => {
        this.spinner.hide();
        this.globalService.showError('Error deleting');
        console.error(err);
      });
  }

  viewCollege(data: any) {
    if (!data) return;
    try {
      // store row and navigate to detail page
      this.globalService.setLocalStore('collegeDetails', JSON.stringify(data));
      this.router.navigate(['/indCollege']);
    } catch (err) {
      console.error('viewCollege failed', err);
    }
  }

  onPageSizeChanged(value: string | number) {
    const pageSize = Number(value) || 10;
    if (this.gridApi && (this.gridApi as any).paginationSetPageSize) {
      (this.gridApi as any).paginationSetPageSize(pageSize);
    }
  }
}
